import { render, staticRenderFns } from "./LiveUpdates.vue?vue&type=template&id=08edc95c&"
import script from "./LiveUpdates.vue?vue&type=script&lang=js&"
export * from "./LiveUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports